<script setup lang="ts">
import { useInit } from './composables/scenes/useInit'
import { useThemeStore } from './stores/theme'
import { useUserStore } from './stores/user'

const { isDark } = storeToRefs(useThemeStore())
const userStore = useUserStore()
const { initializeApp } = useInit()

// 应用初始化
onMounted(() => {
  // 如果还没有初始化，初始化应用
  if (!userStore.initialized) {
    initializeApp()
  }
})
</script>

<template>
  <Toaster :theme="isDark ? 'dark' : 'light'" rich-colors />
  <RouterView />
</template>
